<template>
    <div id="background" class="p-10 w-full text-black">
        <h1 class="text-center">
            We konden deze pagina niet vinden
        </h1>
        <br>
        <h2 class="text-center font-thin text-grey-darkest">
            Je wordt teruggeleid naar de home pagina.
        </h2>
    </div>
</template>

<script>
    export default {
        name: "Http404",
        created() {
            setTimeout(() => {
                this.$router.push('/Home');
            }, 3500);
        }
    }
</script>

<style>
    #background {
        height: 90vh;
        filter: hue-rotate(195deg);
        background-image: url('/img/404.png');
        background-size: cover;
    }
</style>
